"use client";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleXmark,
  faCirclePlus,
} from "@fortawesome/sharp-light-svg-icons";
import React, { useState } from "react";

const FADES = {
  white:
    "absolute inset-0 bg-gradient-to-b from-white/0 via-white/0 to-white/100",
  section:
    "absolute inset-0 bg-gradient-to-b from-white/0 via-white/0 to-[var(--section-bg-color)]",
  out: "hidden",
};

const More: React.FC<{
  children: React.ReactNode;
  /** What the folded text fades into: white, the section's own background colour, or nothing, the text itself fading
   *  out where a background layer shows behind it. */
  fade?: keyof typeof FADES;
}> = ({ children, fade = "white" }) => {
  const [showAll, setShowAll] = useState(false);
  const folded =
    fade === "out"
      ? "h-[100px] [mask-image:linear-gradient(to_bottom,#000_50%,transparent)]"
      : "h-[100px]";

  return (
    <div className="flex flex-col">
      <div
        className={`${showAll ? "" : folded} overflow-hidden relative homepage-text-sm`}
      >
        <div className={`${showAll ? "hidden" : FADES[fade]}`}></div>
        {children}
      </div>
      <div>
        <button
          onClick={() => setShowAll(!showAll)}
          className="border-b flex w-full py-4 gap-1 items-center homepage-text-sm"
        >
          {showAll ? (
            <FontAwesomeIcon className="size-3" icon={faCircleXmark} />
          ) : (
            <FontAwesomeIcon className="size-3" icon={faCirclePlus} />
          )}
          {showAll ? "Mindre" : "Mere"}
        </button>
      </div>
    </div>
  );
};

export default More;
